const FONTS = {
    interFont: "Inter, sans-serif",
    latoFont: "Lato, sans-serif",
    robotoFont: "Roboto, sans-serif"
};

export default FONTS;
